<h1 mat-dialog-title>
    {{title | translate: {contactType: contactType=='mobile'?'cellulare':'indirizzo email'} }}
</h1>
<div mat-dialog-content>
    <app-verify-contact [contactType]="contactType"
                        (output)="closeAfterSubmit($event)"
                        (exit)="closeAfterCancel($event)">
    </app-verify-contact>
</div>